export default "__VITE_ASSET__C_RnoQlb__"